export default "__VITE_ASSET__DyCJ8gNn__"